import React, { Component } from 'react'
//import avatar from "../../assets/avatar.png";
import {Link} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle, faUsersCog, faUserFriends,faFileSignature} from '@fortawesome/free-solid-svg-icons';
import "../../css/admin/SideBar.css";
import { memo } from 'react';
export class SideBar extends Component {

    render() {
        return (
            <div className='col-xl-3  col-lg-12 col-md-12 mt-4 col-sm-12'>
                <div className="container-fluid text-center">
                    {/*<img className="sideBar-avatar" src={avatar} alt="Avatar"></img>*/}
                    <div className='sideBar-infoUsuario'>
                        <p className='sideBar-nombres'>{this.props.nombres}</p>
                        <p className='sideBar-cedula'>{this.props.cedula}</p>
                    </div>
                </div>
                <div className="container-fluid text-left">
                    <ul className='sideBar-ul'>
                        <li className={this.props.tipo==="usuarios"?'sideBar-liSeleccionado sideBar-li':'sideBar-li'}>
                            <FontAwesomeIcon icon={faUserCircle} id='sideBar-icono-link'></FontAwesomeIcon>
                            <Link className="sideBar-link" to="/usuarios">Usuario</Link>
                        </li>
                        <li className={this.props.tipo==="solicitudes"?'sideBar-liSeleccionado sideBar-li':'sideBar-li'}>
                            <FontAwesomeIcon icon={faUsersCog} id='sideBar-icono-link'></FontAwesomeIcon>
                            <Link className="sideBar-link" to="/solicitudes">Solicitudes</Link>
                        </li>
                        <li className={this.props.tipo==="grupos"?'sideBar-liSeleccionado sideBar-li':'sideBar-li'}>
                            <FontAwesomeIcon icon={faUserFriends} id='sideBar-icono-link'></FontAwesomeIcon>
                            <Link className="sideBar-link" to="/grupos">Grupos</Link>
                        </li>
                        <li className={this.props.tipo==="habilitarfirma"?'sideBar-liSeleccionado sideBar-li':'sideBar-li'}>
                            <FontAwesomeIcon icon={faFileSignature} id='sideBar-icono-link'></FontAwesomeIcon>
                            <Link className="sideBar-link" to="/habilitarfirmas">Habilitar Firmas</Link>
                        </li>
                    </ul>
                </div>
            </div>
        )
    }
}

export default memo(SideBar);
